import axios from "axios";

export default axios.create({
  baseURL:
    process.env.REACT_APP_ENV === "PROD"
      ? "https://cm.bookingjini.com/extranetv4"
      : "https://dev.cm.bookingjini.com",
});
